const orderByPosition = obj => {
  return Object.keys(obj)
    .map(key => obj[key])
    .sort((a, b) => a.position - b.position)
}

export default orderByPosition
